import React from 'react'
import {Col, Form} from 'react-bootstrap'
import {TModuleInfo, TModuleInfoArea, TModuleInfoBlock, TModuleInfoField} from './_types'
import ComponentButton from '../../components/ComponentButton'
import ComponentInfo from '../../components/ComponentInfo'
import ComponentTooltip from '../../components/ComponentTooltip'

const getAreaKey = (area: TModuleInfoArea) =>
    `${area.size}${area.blocks.map((b) => b.title).join('-')}`

const InfoField: React.FC<TModuleInfoField> = ({title, value, data_type, field_type}) => {
    return (
        <div className='moduleInfo_field'>
            <div className='moduleInfo_field_labelContainer'>
                <ComponentTooltip title={title}>
                    <label className='moduleInfo_field_label'>{title}</label>
                </ComponentTooltip>
            </div>

            <div className='moduleInfo_field_component'>
                <ComponentInfo value={value} data_type={data_type} field_type={field_type} />
            </div>
        </div>
    )
}

const InfoBlock: React.FC<TModuleInfoBlock> = ({title, fields}) => {
    return (
        <div className='moduleInfo_block card'>
            {title ? (
                <div className='card-header align-items-center'>
                    <div className='card-title card_title_wrapper'>
                        <h3 className='mb-0'>{title}</h3>
                    </div>
                </div>
            ) : null}

            <div className='card-body'>
                <div className='moduleInfo_block_fields'>
                    {fields.map((field) => (
                        <InfoField key={field.article} {...field} />
                    ))}
                </div>
            </div>
        </div>
    )
}

const ModuleInfo: React.FC<TModuleInfo> = ({settings, components}) => {
    const {areas} = settings
    const buttons = Array.isArray(components) ? [] : components.buttons

    const isSingleEditor =
        areas.length === 1 &&
        areas[0].blocks.length === 1 &&
        areas[0].blocks[0].fields.length === 1 &&
        areas[0].blocks[0].fields[0].field_type === 'editor'

    if (isSingleEditor) {
        const field = areas[0].blocks[0].fields[0]

        return (
            <div className='moduleInfo moduleInfo--singleEditor'>
                <div className='moduleInfo__editor'>
                    <ComponentInfo
                        value={field.value}
                        field_type='editor'
                        data_type={field.data_type}
                    />
                </div>

                {buttons.length > 0 ? (
                    <div className='moduleInfo__buttons mt-4'>
                        {buttons.map((button) => (
                            <ComponentButton key={button.type} {...button} />
                        ))}
                    </div>
                ) : null}
            </div>
        )
    }

    return (
        <div className='moduleInfo'>
            <div className='moduleInfo_container'>
                {areas.map((area) => (
                    <Form.Group
                        key={getAreaKey(area)}
                        as={Col}
                        md={area.size * 3}
                        className='moduleInfo_area'
                    >
                        {area.blocks.map((block) => (
                            <InfoBlock key={block.title} {...block} />
                        ))}
                    </Form.Group>
                ))}
            </div>

            <Form.Group as={Col} md={12} className='moduleInfo__footer'>
                <div className='moduleInfo__buttons'>
                    {buttons.map((button) => (
                        <ComponentButton key={button.type} {...button} />
                    ))}
                </div>
            </Form.Group>
        </div>
    )
}

export default ModuleInfo
